import { JSONApiRelation, JSONApiResourceBase } from '../interfaces/JSONApi.js'

export interface Form extends JSONApiResourceBase {
  type: 'forms'
  attributes: {
    name?: string
    displayOn?: FormDisplayOn
    config: FormConfig
  }
  relationships: {
    organization: JSONApiRelation
    campaign: JSONApiRelation
  }
}

export interface FormConfig {
  firstPage?: string
  requirePhoneCall: boolean
  webhookUrl?: string
  pages: {
    [key: string]: FormPage
  }
}

export interface FormPage {
  id: string
  title: string
  description?: string
  questions: Array<FormQuestion>
  nextPage?: string
}

export interface FormQuestion {
  id: string
  slug?: string
  type: FormQuestionTypes
  text: string
  order: number
  required?: boolean
  options?: Array<{ option: string; nextPage?: string }>
  optionsGoToNextPage?: boolean
}

export enum FormQuestionTypes {
  SHORT_ANSWER = 'SHORT_ANSWER',
  LONG_ANSWER = 'LONG_ANSWER',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  CHECKBOXES = 'CHECKBOXES',
  SWITCH = 'SWITCH',
  DROPDOWNS = 'DROPDOWNS',
  DATE = 'DATE',
  TIME = 'TIME',
  HEADER = 'HEADER',
  PARAGRAPH = 'PARAGRAPH',
}

export enum FormDisplayOn {
  LEAD = 'LEAD',
  INBOUND = 'INBOUND',
}
